export default __webpack_public_path__ + "static/2-bec88d2b4372eacf248ec25ab7f865b7.jpeg";